import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveACCOUNTInfoinAllApplications, zipAndBranchDetail } from '../../../AdminActionCreator.component';
import moment from 'moment';

const OtherIncomeData = [
    { label: "Yes", value: true },
    { label: "No", value: false },
]


const textFieldData = [
    { label: "Name As on Bank Account", value: "nameAsBankAccount", placeholder: "Enter Name As on Bank Account", type: "text", name: "nameAsBankAccount" },
    { label: "Bank Name", value: "bankName", placeholder: "Enter Bank Name", type: "text", name: "bankName" },
    { label: "Account Number", value: "accountNumber", placeholder: "Enter Account Number", type: "number", name: "accountNumber" },
    { label: "IFSC Code", value: "ifscCode", placeholder: "Enter IFSC Code", type: "text", name: "ifscCode" },
    { label: "Bank Branch", value: "bankBranch", placeholder: "Enter Bank Branch", type: "text", name: "bankBranch" },
    { label: "Account Type", value: "ifSalariedAccount", placeholder: "Enter Account Type", type: "text", name: "ifSalariedAccount" },

]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup }) {
    const [objectData, setObjectData] = useState({
        "nameAsBankAccount": "",
        "bankName": "",
        "accountNumber": "",
        "ifscCode": "",
        "bankBranch": "",
        "ifSalariedAccount": "",


    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

         if (name == "ifscCode" && e.target.value?.length == 11) {
                handlezipAndBranchDetailFn(e.target.value)
        }

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "nameAsBankAccount": data?.nameAsBankAccount || "",
                "bankName": data?.bankName || "",
                "accountNumber": data?.accountNumber || "",
                "ifscCode": data?.ifscCode || "",
                "bankBranch": data?.branch || "",
                "ifSalariedAccount": data?.ifSalariedAccount || "",
            })
        } else {
            setObjectData({
                "nameAsBankAccount": "",
                "bankName": "",
                "accountNumber": "",
                "ifscCode": "",
                "bankBranch": "",
                "ifSalariedAccount": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId }
        handleLoader(true)
        SaveACCOUNTInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Employment Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Employment Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }

    const handlezipAndBranchDetailFn = (value) => {
            handleLoader(true)
            zipAndBranchDetail(value, 'branch', res => {
                handleLoader(false)
                if (res.status === 'success') {
                    setObjectData((prev)=>({
                        ...prev,
                         bankBranch: res.branchName
                    }))
                }
            })
        }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Employemnt Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "otherIncome" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "otherIncome" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {OtherIncomeData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>

                                                    :
                                                    ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
